import React from 'react';
import { connect, history } from 'umi';

import { isEmpty } from 'lodash';

import copy from 'copy-to-clipboard';
import QRCode from 'qrcode.react';

import { Text, Button, Divider } from '@digitalc/dxp-ui';
import { Toast } from 'antd-mobile';

import { CouponStateOption } from '@/utils/constants';
import { Clickable } from '@/components';
import { onHistoryPush, getThemeImgByKey, formatDate, getDate } from '@/utils/utils';
import useGCPI18n from '@/hooks/useGCPI18n';
import convertSuccess from '@/assets/images/point/convertSuccess.png';
import rewardDate from '@/assets/images/reward_date.svg';
import voucherDefault from '@/assets/images/point/voucherDefault.png';
import cardLeft from '@/assets/images/card_left.png';
import cardRight from '@/assets/images/card_right.png';
import voucherExpired from '@/assets/images/point/voucherExpired.png';
import voucherUsed from '@/assets/images/point/voucherUsed.png';
import voucherValid from '@/assets/images/point/voucherValid.png';
import copyIcon from '@/assets/images/point/copy.svg';

import styles from './index.less';

const { VALID, EXPIRED, USED } = CouponStateOption;
const ClaimSuccessfull = props => {
  const { dxpToken } = props;

  const { detail } = history?.location?.query || {};
  const GCPI18n = useGCPI18n();

  const {
    couponState,
    couponName,
    couponSn,
    couponImageUrl,
    expDate,
    redeemEndTime,
    availableRedeemList,
    redeemList,
  } = detail || {};

  const isVaild = couponState === VALID; // 可使用
  const isExpried = couponState === EXPIRED; // 过期
  const isUsed = couponState === USED; // 已使用
  const isRedeem = !isEmpty(availableRedeemList);

  const needLine = !isExpried && !isEmpty(couponSn);

  const copySuccess = GCPI18n({ id: 'lb_point_my_voucher_copy_successfully' });
  const handleCopy = value => {
    copy(value);
    Toast.show({ icon: 'success', content: copySuccess });
  };

  const getVoucherStatePicture = () => {
    if (isVaild) {
      return voucherValid;
    }
    if (isExpried) {
      return voucherExpired;
    }
    if (isUsed) {
      return voucherUsed;
    }
    return null;
  };

  const renderCardBg = () => (
    <div className={`${styles.bgCard} ${needLine && styles.needLine}`}>
      <img src={cardLeft} alt="" className={styles.cardLeft} />
      <div className={styles.line} />
      <img src={cardRight} alt="" className={styles.cardRight} />
    </div>
  );

  return (
    <div className={styles.successPage}>
      <div className={styles.imgWrap}>
        <img src={getThemeImgByKey('genericSuccess') || convertSuccess} alt="" />
      </div>

      <Text breakpoint="Mobile" size="TitleT23Bold" style={{ color: dxpToken.colorTextNeutral }}>
        {GCPI18n('lb_my_rewards_all_detail_claim_success')}
      </Text>

      <Divider style={{ margin: '0.16rem 0rem' }} />
      <div className={styles.voucherDetail}>
        <div className={`${styles.content} ${isExpried && styles.disabled}`}>
          <div className={styles.detail}>
            <div className={styles.left}>
              <img src={couponImageUrl || voucherDefault} alt="" />
            </div>
            <div className={styles.right}>
              <div className={styles.voucherName}>{couponName}</div>
              <div className={styles.timeBox}>
                <img src={rewardDate} alt="" />
                <div>
                  {GCPI18n({ id: 'lb_my_rewards_all_card_valid_till' })}{' '}
                  {getDate(expDate, redeemEndTime, true)}
                </div>
              </div>
            </div>
            <div className={styles.stateWrap}>
              <img src={getVoucherStatePicture()} alt="" />
            </div>
            {renderCardBg()}
          </div>
          {isRedeem && isUsed && (
            <div className={styles.redeemListBox}>
              <div className={styles.title}>{GCPI18n({ id: 'lb_redemption_details' })}</div>
              <div className={styles.redeemList}>
                {redeemList.map((it, i) => (
                  <div className={styles.item} key={it.objCode}>
                    <div className={styles.label}>
                      {GCPI18n({ id: 'lb_prize_voucher' })} {i + 1}
                    </div>
                    <div className={styles.value}>{it.objName}</div>
                  </div>
                ))}
                <div className={styles.item}>
                  <div className={styles.label}>{GCPI18n({ id: 'lb_redemption_ime' })}</div>
                  <div className={styles.value}>{formatDate(redeemList[0].redeemTime)}</div>
                </div>
              </div>
            </div>
          )}
          {couponSn && !isExpried && !isUsed && (
            <div className={styles.qrCodeBox}>
              <QRCode className={styles.qrCode} value={couponSn} level="H" />
              <div className={styles.codeWrap}>
                {GCPI18n({
                  id: 'lb_point_my_voucher_code',
                })}
                : {couponSn}
                <span className={styles.copy}>
                  {GCPI18n({ id: 'btn_copy' })}
                  <Clickable as="img" src={copyIcon} alt="" onClick={() => handleCopy(couponSn)} />
                </span>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className={styles.footer}>
        <Button
          block
          type="primary"
          onClick={() => {
            onHistoryPush('/pointshop/myVoucher');
          }}
        >
          {GCPI18n({
            id: 'lb_back_my_voucher',
          })}
        </Button>
      </div>
    </div>
  );
};

export default connect(({ index }) => ({
  dxpToken: index.dxpToken,
}))(ClaimSuccessfull);
